// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Zavrieť',
  error: () => 'Chyba',
  warn: () => 'Upozornenie',
  info: () => 'Informácie',
  confirmation: () => 'Potvrdenie',
  progressIndeterminate: () => 'Prebieha',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Medzi ' + p['FROM_SECTION'] + ' a ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nenašla sa žiadna zodpovedajúca sekcia.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Stlačte kláves Enter a vyberte hodnotu.',
  indexer_touchInstructionText: () =>
    'Dvakrát ťuknite a podržte na zadanie režimu gest, potom posunutím nahor alebo nadol upravte hodnotu.',
  inputPassword_show: () => 'Zobraziť heslo',
  inputPassword_hide: () => 'Skryť heslo',
  inputPassword_hidden: () => 'Skryté heslo',
  formControl_clear: () => 'Vymazať',
  formControl_loading: () => 'Zavádza sa',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximálna dĺžka ' + p['MAX_LENGTH'] + ' bola prekročená.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Počet zostávajúcich znakov: ' + p['CHARACTER_COUNT'] + '.',
  formControl_requiredMessageDetail: () => 'Zadajte hodnotu.',
  select_requiredMessageDetail: () => 'Vyberte hodnotu.',
  select_noMatchesFound: () => 'Nenašli sa žiadne zhody.',
  select_oneMatchFound: () => 'Našla sa jedna zodpovedajúca hodnota',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Nájdené zhody: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Nájdené zhody: ' + p['TOTAL_SIZE'] + ' alebo viac',
  selectMultiple_selectedValues: () => 'Vybrané hodnoty',
  selectMultiple_showSelectedValues: () => 'Zobraziť len vybrané hodnoty.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Počet vybraných hodnôt: ' + p['VALUE_COUNT'] + '.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Na odobratie vybranej hodnoty stlačte klávesy Backspace alebo Delete.',
  selectMultiple_apply: () => 'Použiť',
  selectMultiple_back: () => 'Späť',
  selector_selected: () => 'Políčko je začiarknuté',
  selector_unselected: () => 'Políčko nie je začiarknuté',
  userAssistance_learnMore: () => 'Ďalšie informácie',
  userAssistance_required: () => 'Povinné',
  filePicker_singleFileUploadError: () => 'Súbory nahrávajte po jednom',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Súbory typu ' + p['fileType'] + ' nie je možné nahrať',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Súbory typu ' + p['fileTypes'] + ' nie je možné nahrať',
  filePicker_unknownFileTypeUploadError: () => 'neznáme',
  filePicker_dropzonePrimaryText: () => 'Presunutie myšou',
  filePicker_dropzoneSecondaryText: () => 'Vyberte súbor alebo sem presuňte nejaký súbor',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Vyberte súbory alebo sem presuňte nejaké súbory',
  filePicker_addFiles: () => 'Pridať súbory',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Zvýšiť',
  inputNumber_decrease: () => 'Znížiť',
  inputNumber_converterParseError: () => 'Zadajte číslo.',
  noData_message: () => 'Neexistujú položky na zobrazenie',
  message_navigationFromMessagesRegion: () =>
    'Vstupujete do oblasti správ. Stlačte kláves F6, ak sa chcete vrátiť na predchádzajúci aktívny prvok.',
  message_navigationToMessagesRegion: () =>
    'Oblasť správ obsahuje nové správy. Stlačením klávesu F6 prejdete do oblasti s najnovšou správou.',
  messageToast_allMessagesClosed: () => 'Všetky vyskakovacie oznámenia sú zavreté.',
  expandableList_groupCollapse: () => 'Zbalené',
  expandableList_groupExpand: () => 'Rozbalené',
  expandableList_expandCollapseInstructionText: () =>
    'Na rozbalenie a zbalenie použite klávesy so šípkami',
  list_suggestion: () => 'Návrh',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Krok ' + p['currentStep'] + ' z ' + p['numberOfSteps'],
  train_current: () => 'Aktuálny',
  train_visited: () => 'Navštívený',
  train_not_visited: () => 'Nenavštívený',
  train_message_type: () => 'Typ hlásenia',
  viz_drillable: () => 'Možno použiť funkciu prechodu',
  dataVisualization_stateSelected: () => 'Vybrané',
  dataVisualization_stateUnselected: () => 'Nevybrané',
  dataVisualization_noData: () => 'Žiadne dáta na zobrazenie'
};
export default bundle;
